import { render } from "./BlogModal.vue?vue&type=template&id=54b4b13b"
import script from "./BlogModal.vue?vue&type=script&lang=js"
export * from "./BlogModal.vue?vue&type=script&lang=js"

import "./BlogModal.vue?vue&type=style&index=0&id=54b4b13b&lang=scss"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__